module.exports = __webpack_public_path__ + "img/Icon-feather-mouse-pointer.9a3d6491.svg";